import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "", once = true }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once, margin: "-60px" }}
        transition={{ duration: 0.7, delay, ease: [0.22, 0.6, 0.24, 1] }}
    >
        {children}
    </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
    <span className={`block overflow-hidden ${className}`}>
        <motion.span
            className="block"
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 0.9, delay, ease: [0.22, 0.6, 0.24, 1] }}
        >
            {children}
        </motion.span>
    </span>
);

export const GoldLine = ({ delay = 0, className = "" }) => (
    <motion.div
        className={`h-px bg-gold/60 ${className}`}
        initial={{ scaleX: 0 }}
        whileInView={{ scaleX: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1, delay, ease: "easeInOut" }}
        style={{ transformOrigin: "left" }}
    />
);

export default Reveal;
